import(/* webpackMode: "eager", webpackExports: ["PlanContent"] */ "/app/src/pages/plan/ui/plan-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlanBanner"] */ "/app/src/shared/ui/plan-banner.tsx");
